export enum Status {
  draft = 'Draft',
  published = 'Published',
  booked = 'Booked',
  active = 'Active',
  delivered = 'Delivered',
  documents = 'Documents uploaded',
  invoiced = 'Invoiced',
  paid = 'Paid',
  cancelled = 'Cancelled',
  cancelledShipper = 'Cancelled (S)',
  cancelledHaulier = 'Cancelled (H)',
  unassigned = 'Unassigned',
  pending = 'Pending',
  rejected = 'Rejected',
  change = 'Change',
}
